import { forwardRef, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DateCalendar } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

import Icon from 'atoms/icon';

const DatePicker = forwardRef(({ date }, ref) => {
  const divRef = useRef(null);
  const [displayCalendar, toggleCalendar] = useState(false);
  const [value, setValue] = useState(dayjs(date));

  useEffect(() => {
    setValue(dayjs(date));
  }, [date]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      toggleCalendar(false);
    }
  };

  const onSelectDate = (date) => {
    const dateStr = dayjs(date).format('YYYY-MM-DD');
    const calendarApi = ref.current.getApi();
    calendarApi.gotoDate(dateStr);
    toggleCalendar(false);
  };

  return (
    <div className="calendar-date-picker">
      <Icon
        onClick={() => toggleCalendar(!displayCalendar)}
        name="calendar"
        className="pointer"
        pointer
        width={20}
        height={20}
        fill="#ACACC0"
      />
      {displayCalendar && (
        <div
          ref={divRef}
          className="pos-absolute b-white calendar-date-picker-popover"
        >
          <DateCalendar value={value} onChange={onSelectDate} />
        </div>
      )}
    </div>
  );
});

export default DatePicker;
